import { defineMessages, useIntl } from 'react-intl';
import { Onboarding } from '../modules/Onboarding';
import Layout from '../modules/Layout';
import { CustomNextPage } from '../lib/types';
import { getQueryString } from '../lib/utils';
import { bootstrap } from '../lib/bootstrap';
import { pushRoute } from '../components/Link';

const messages = defineMessages({
  title: {
    id: 'pages.onboarding.title',
    defaultMessage: 'Onboarding'
  }
});

const route = 'onboarding';

const OnboardingPage: CustomNextPage<{}> = ({ url }) => {
  const intl = useIntl();
  const stepId = getQueryString(url.query.step);

  return (
    <Layout
      title={intl.formatMessage(messages.title)}
      url={url}
      loading={false}
      hideChrome
      requiresAuth
      hideIntercomLauncher
      contentProps={{
        // Override Content defaultProps
        py: 0,
        mx: 0,
        mb: 0
      }}
      render={() => {
        return (
          <Onboarding
            stepId={stepId}
            setStepId={stepId => {
              pushRoute({
                route,
                params: {
                  step: stepId
                },
                options: {
                  shallow: true
                },
                intl
              });
            }}
            onStepFound={currentStepId => {
              if (stepId || stepId === currentStepId) {
                return;
              }
              pushRoute({
                route,
                params: { ...url.query, step: currentStepId },
                options: { shallow: true },
                intl
              });
            }}
            onFinished={() => {
              pushRoute({
                route: 'how-it-works',
                params: {
                  from: 'post-checkout'
                },
                intl
              });
            }}
          />
        );
      }}
    />
  );
};

export default bootstrap(OnboardingPage);
